var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBonusBubleWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.59 99.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-2938.58 -166.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3022.63 208.4q13.66 34.75-18.33 41.56c-32 6.8-47.08-8.17-51.13-22.12s8.46-46.86 32.29-49.05q23.84-2.17 37.17 29.61Z",
    style: {
      clipRule: "evenodd",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    transform: "translate(-2938.58 -166.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2078.47h1722L4055.38 0h-1722L0 2078.47z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2946.37 173.91h83v83.71h-83z",
    style: {
      fill: "#eff3f5"
    },
    transform: "rotate(-12 727.944 14112.036)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusBubleWhite);
export default __webpack_public_path__ + "static/media/bonus-buble-white.34ed4d110d5bac211eae05c094c58882.svg";
export { ForwardRef as ReactComponent };